module.exports = __webpack_public_path__ + "da3d7699ca4c14e80969e0f0c76df36d.pdf";